import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TextSearchService } from 'src/app/services/text-search.service';

@Component({
  selector: 'app-text-search-ras',
  templateUrl: './text-search-ras.component.html',
  styleUrls: ['./text-search-ras.component.scss'],
})
export class TextSearchRasComponent implements OnInit {
  optionTextSearch = ['Todos', 'Casos', 'Tareas'];
  optionSelect = 'Todos';
  filters = [];
  form: FormGroup = this.fb.group({
    filters: [],
  });
  text: string;
  constructor(
    public readonly textSearchService: TextSearchService,
    public fb: FormBuilder
  ) {}

  ngOnInit() {
    this.textSearchService.filterToPage.subscribe((data: any) => {
      this.search(data);
    });
  }

  search(options) {
    this.textSearchService.rasSearchText(options).subscribe((response) => {
      this.textSearchService.dataToContent.next({
        cases: response.cases,
        task: response.task,
        option: options.option,
      });
    });
  }
}
